export interface ProductRequest {
  hardwareModel: string;
  serialNo: string;
  alias: string;
}

export enum HardwareModels {
  PicoNeo3ProEye = "pn3",
  Pico4Enterprise = "p4e",
  Dpvr = "dp2",
  PicoSwan = "psw",
  HtcFocusVision = "htcfv",
}

export enum HeadsetVersion {
  ver_1_0 = "1.0",
  ver_2_3 = "2.3",
  ver_2_4 = "2.4",
  ver_2_6 = "2.6",
  ver_2_6_2 = "2.6.2",
  ver_2_6_3 = "2.6.3",
  ver_2_6_4 = "2.6.4",
  ver_2_6_5 = "2.6.5",
  ver_2_6_6 = "2.6.6",
  ver_2_6_7 = "2.6.7",
  ver_2_7 = "2.7",
  ver_2_7_1 = "2.7.1",
  ver_2_7_3 = "2.7.3",
  ver_2_7_4 = "2.7.4",
  ver_2_7_8 = "2.7.8",
  ver_2_7_9 = "2.7.9",
  ver_2_7_10 = "2.7.10",
  ver_2_7_11 = "2.7.11",
  ver_2_7_12 = "2.7.12",
  ver_2_7_14 = "2.7.14",
  ver_2_8 = "2.8",
  ver_2_8_1 = "2.8.1",
  ver_2_8_2 = "2.8.2",
  ver_2_8_3 = "2.8.3",
  ver_2_8_4 = "2.8.4",
  ver_2_8_5 = "2.8.5",
  ver_2_8_6 = "2.8.6",
  ver_2_8_7 = "2.8.7",
  ver_2_9 = "2.9",
  n_a = "999.999.999", // Represents future versions
}

export enum ControllerConnectionState {
  None = "none",
  LeftOnly = "left",
  RightOnly = "right",
  Both = "both",
  Error = "error",
}

export interface ControllerBatteryState {
  left: number | null;
  right: number | null;
}
